// « Ajouter une personnalité » (15 octobre 2026) : la fenêtre, ses deux étapes.
// Le genre d'une personne n'est jamais deviné : « ses comptes », « sa fiche ».
export default {
  titre: 'Ajouter une personnalité',
  etapes: { qui: 'Qui', comptes: 'Ses comptes' },
  qui: {
    aide: 'Quelqu’un qui n’est pas encore dans l’annuaire : un élu local, une figure d’un parti, un ancien ministre.',
    libelle: 'Qui ?',
    placeholder: 'Un prénom et un nom',
    resultats: 'Résultats',
    recherche: 'Recherche…',
    aucun: 'Personne ne correspond à « {q} ».',
    erreur: 'La recherche n’a pas abouti. Réessayez dans un instant.',
    deja: 'Déjà dans l’annuaire',
    voirFiche: 'Voir sa fiche',
    manque: 'Choisissez une personne parmi les résultats.',
    annuaire: 'Les parlementaires, les eurodéputés, le Gouvernement, les chefs de parti, les présidents de région et les maires des grandes villes sont déjà dans l’annuaire : il suffit de les suivre depuis Personnalités.',
  },
  comptes: {
    legende: 'Ses comptes, écoutés chaque jour',
    aucun: 'Aucun compte trouvé : ajoutez ceux que vous connaissez.',
    ajouterUn: 'Ajouter un compte',
    adresse: 'L’adresse du compte',
    placeholder: 'x.com/son_compte, instagram.com/…',
    ajouter: 'Ajouter',
    renoncer: 'Ne pas ajouter de compte',
    invalide: 'Une adresse de compte ou de site, par exemple x.com/son_compte.',
    ailleurs: 'Orion écoute aussi ce qui se dit partout ailleurs.',
    reste: 'Après ce suivi, il vous en restera {n} sur {max}.',
    dernier: 'Ce suivi sera le dernier de vos {max}.',
    complets: 'Vos {max} suivis sont utilisés : la personnalité entrera dans l’annuaire, sans suivi.',
  },
  terminer: 'Ajouter et suivre',
  erreur: 'L’ajout n’a pas abouti.',
  sansSuivi: {
    titre: '{nom} entre dans l’annuaire, sans suivi',
    texte: 'Sa fiche est déjà ouverte. Vous pourrez suivre cette personnalité dès qu’un suivi se libère.',
    introuvable: 'Sa fiche se trouve dans Personnalités, sous « Ajoutées ».',
    ouvrir: 'Ouvrir sa fiche',
  },
}
